import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import { getRewards } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import {
  mapRewardsViewQuery,
  rewardsViewColumns,
  rewardsSearchSchema,
} from "./RewardsView.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface RewardsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function RewardsView(props: RewardsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={rewardsViewColumns}
      schema={rewardsSearchSchema}
      mapQuery={mapRewardsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getRewards, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "assignReward",
          label: "Assign Reward",
          disabled: !permissions.can("Rewards", "create"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("Rewards", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Rewards", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default RewardsView;
